import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@material-ui/core';
import medicionesStyles from './medicionesStyles';

/**
 * Contenido provisional del área de un módulo sin panel registrado
 * (features 10-13 lo reemplazan registrando su panel en panelesModulo.js).
 */
const ModuloPlaceholder = ({ modulo }) => {
	const classes = medicionesStyles();
	return (
		<Paper className={classes.placeholder}>
			<Typography variant="h6" component="h3" className={classes.placeholderTitle}>
				{modulo.label}
			</Typography>
			<Typography className={classes.placeholderText}>
				Este módulo aún no permite registrar datos.
			</Typography>
		</Paper>
	);
};

ModuloPlaceholder.propTypes = {
	modulo: PropTypes.shape({
		id: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
	}).isRequired,
};

export default ModuloPlaceholder;
